import React from 'react';
import { Input, Select, Button } from 'antd';

interface AddFieldBoxProps {
  newColumn: { name: string; alias: string; dataType: string | undefined };
  setNewColumn: React.Dispatch<React.SetStateAction<{ name: string; alias: string; dataType: string | undefined }>>;
  onSave: () => void;
}

const AddFieldBox: React.FC<AddFieldBoxProps> = ({ newColumn, setNewColumn, onSave }) => {
  return (
    <div className="addFieldBox">
      <div className="inputRow">
        <Input
          placeholder="Field"
          value={newColumn.name}
          onChange={(e) => setNewColumn({ ...newColumn, name: e.target.value })}
          size="small"
          maxLength={63}
        />
        <Input placeholder="Alias" value={newColumn.alias} onChange={(e) => setNewColumn({ ...newColumn, alias: e.target.value })} size="small" />
        <Select
          placeholder="Data Type"
          value={newColumn.dataType}
          onChange={(val) => setNewColumn({ ...newColumn, dataType: val })}
          size="small"
          options={[
            { label: 'Text', value: 'Text' },
            { label: 'Integer', value: 'Integer' },
            { label: 'Float', value: 'Float' },
            { label: 'Date', value: 'Date' },
          ]}
        />
      </div>

      <Button type="primary" block onClick={onSave}>
        Save and Close
      </Button>
    </div>
  );
};

export default AddFieldBox;
